import { AnyRoute, createRoute, lazyRouteComponent } from '@tanstack/react-router'
import { z } from 'zod'

const searchSchema = z.object({
  returnUrl: z.string().optional()
})

export const ManageRoute = <T extends AnyRoute>(indexRoute: T) =>
  createRoute({
    getParentRoute: () => indexRoute,
    path: `$id/edit`,
    component: lazyRouteComponent(() => import('./ManageCTR')),
    validateSearch: (search) => searchSchema.parse(search)
  })
